import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { locationServiceCookies } from 'yoda-site-components/lib/common/Constants';

export const getStoreId = () => {
    /* istanbul ignore next */
    try {
        const akamaiStore = Cookies.load(locationServiceCookies.akamaiStore);
        if (akamaiStore) {
            const akamaiStoreData = JSON.parse(akamaiStore);
            return akamaiStoreData.storeId;
        }
    } catch (err) {
        return '';
    }
    return '';
};

export default getStoreId;
